export type CompGetInfoV2ApiResponse =
  | /** status 200 Standard response */ ({
      businessId?: string | null;
      taxId?: string | null;
      fileNumber?: string | null;
      businessName?: string | null;
      prefix?: string | null;
      street?: string | null;
      orientationNumber?: string | null;
      descriptiveNumber?: string | null;
      city?: string | null;
      zipCode?: string | null;
      postal?: string | null;
      state?: string | null;
      country?: string | null;
    } | null)
  | /** status 204 Standard response */ void;
export type CompGetInfoV2ApiArg = {
  /** CZE, SVK = ICO; POL - REGON(9) */
  id?: string | null;
  /** Eureopan standard for VAT identification */
  vatId?: string | null;
  country: ('CZE' | 'SVK' | 'POL') | null;
};
export type CompGetVatBankAccountsApiResponse =
  | /** status 200 Standard response */ ({
      account?: ({
        type?: ('local' | 'international') | null;
        date?: string | null;
        prefix?: string | null;
        account?: string | null;
        bankCode?: string | null;
      } | null)[];
    } | null)
  | /** status 204 Standard response */ void;
export type CompGetVatBankAccountsApiArg = {
  /** CZE = DIC */
  id: string | null;
};
export type CompGetVatInfoApiResponse =
  | /** status 200 Standard response */ ({
      vatNumberCountry: string | null;
      vatNumber: string | null;
      valid?: boolean | null;
      name?: string | null;
      address?: string | null;
    } | null)
  | /** status 204 Standard response */ void;
export type CompGetVatInfoApiArg = {
  id: string | null;
};
export type CompGetVatUnreliableInfoApiResponse =
  | /** status 200 Standard response */ ({
      vat?: string | null;
      unreliable?: boolean | null;
      unreliableFromDate?: string | null;
    } | null)
  | /** status 204 Standard response */ void;
export type CompGetVatUnreliableInfoApiArg = {
  id: string | null;
};
export type CompGetInfoV3ApiResponse =
  /** status 200 Standard response */
  | ({
      businessId?: string | null;
      taxId?: string | null;
      fileNumber?: string | null;
      businessName?: string | null;
      prefix?: string | null;
      street?: string | null;
      orientationNumber?: string | null;
      descriptiveNumber?: string | null;
      city?: string | null;
      zipCode?: string | null;
      postal?: string | null;
      district?: string | null;
      state?: string | null;
      country?: string | null;
      personSelfEmployee?: {
        firstName?: string | null;
        lastName?: string | null;
        titleBeforeName?: string | null;
        titleAfterName?: string | null;
      } | null;
    } | null)[]
  | /** status 204 Standard response */ undefined;

export type CompGetInfoV3ApiArg = {
  /** CZE, SVK = ICO; POL - REGON(9) */
  id?: string | null;
  /** Eureopan standard for VAT identification */
  vatId?: string | null;
  country: ('CZE' | 'SVK' | 'POL') | null;
};
